import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { useCallback } from 'react';

import { UserAvatar } from '../../UserSection';
import {
  BURGER_MENU_TAB_ICON_WRAPPER,
  BURGER_MENU_TAB_LABEL_WRAPPER,
  BURGER_MENU_TAB_ROOT,
  TAB_ICON,
} from '../constants';
import { BurgerMenuTabLabelWrapper, BurgerMenuTabPrefixWrapper, BurgerMenuTabRoot } from './styles';
import type { BurgerMenuTabProps } from './types';

export const BurgerMenuTab: FC<BurgerMenuTabProps> = ({
  children,
  activeTab,
  tabPrefix,
  tabName,
  onTabClick,
  isLoggedIn,
}) => {
  const clickHandler = useCallback(() => onTabClick(tabName), [onTabClick, tabName]);
  const TabIcon = tabPrefix;
  const ownerState = { isActive: activeTab === tabName, isLoggedIn };
  const { getTestId } = useTestId();

  return (
    <BurgerMenuTabRoot
      disableRipple
      ownerState={ownerState}
      data-testid={getTestId(BURGER_MENU_TAB_ROOT)}
      onClick={clickHandler}
    >
      <BurgerMenuTabPrefixWrapper
        ownerState={ownerState}
        data-testid={getTestId(BURGER_MENU_TAB_ICON_WRAPPER)}
      >
        {typeof tabPrefix === 'string' ? (
          <UserAvatar data-testid={getTestId(TAB_ICON)}>{tabPrefix}</UserAvatar>
        ) : (
          <TabIcon
            fontSize="inherit"
            data-testid={getTestId(TAB_ICON)}
          />
        )}
      </BurgerMenuTabPrefixWrapper>
      <BurgerMenuTabLabelWrapper data-testid={getTestId(BURGER_MENU_TAB_LABEL_WRAPPER)}>
        {children}
      </BurgerMenuTabLabelWrapper>
    </BurgerMenuTabRoot>
  );
};
